import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AkBreadcrumbs from '@atlaskit/breadcrumbs';

import { BreadcrumbsItem } from '@confluence/breadcrumbs/entry-points/BreadcrumbsItem';
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext';
import { GenericBreadcrumbItemTitles } from '@confluence/breadcrumbs/entry-points/constants';

export class Breadcrumbs extends PureComponent {
	_noLinkItem = ({ children }) => <span>{children}</span>;

	analyticsAttributesCreator =
		({ origin, breadcrumbItemsCount, contentType, contentId }) =>
		({ url, nestedDepth, routeName, titleLength }) => ({
			breadcrumbItemsCount,
			nestedDepth,
			origin,
			contentType,
			contentId,
			titleLength,
			get destination() {
				if (routeName) {
					return routeName;
				} else if (url === '/wiki/peopledirectory.action') {
					return GenericBreadcrumbItemTitles.People;
				} else if (/display\/~[0-9a-zA-Z]+$/.test(url)) {
					// eg. /wiki/display/~820701666
					return GenericBreadcrumbItemTitles.PersonalSpace;
				} else if (contentType === 'blogpost' && /\/\d{4}\/\d{2}$/.test(url)) {
					// eg. /wiki/display/820701666/2021/04
					return GenericBreadcrumbItemTitles.BlogMonth;
				}
			},
		});

	render() {
		const {
			breadcrumbs,
			origin,
			contentId,
			contentType,
			maxItems,
			itemsBeforeCollapse,
			itemsAfterCollapse,
			clickHandler,
			disabled,
		} = this.props;
		const editorBreadcrumbClickAnalytics = this.analyticsAttributesCreator({
			origin,
			breadcrumbItemsCount: breadcrumbs.length,
			contentType,
			contentId,
		});

		const limits = maxItems ? { maxItems, itemsBeforeCollapse, itemsAfterCollapse } : {};

		return (
			<RoutesContext.Consumer>
				{({ matchRoute }) => (
					<AkBreadcrumbs {...limits} testId="editor-breadcrumbs">
						{Array.isArray(breadcrumbs) &&
							breadcrumbs.map(({ url, title }, index) => {
								const nestedDepth = index + 1;

								return url ? (
									<BreadcrumbsItem
										href={!disabled ? url : undefined}
										key={index}
										text={title}
										truncationWidth={index === 0 ? 160 : 240}
										onClick={
											clickHandler && !disabled
												? (destinationUrl) => clickHandler(destinationUrl)
												: undefined
										}
										clickEventAnalyticsAttributes={editorBreadcrumbClickAnalytics({
											url,
											nestedDepth,
											routeName: matchRoute(url)?.name,
											titleLength: title.length,
										})}
									/>
								) : (
									<BreadcrumbsItem
										component={this._noLinkItem}
										key={index}
										text={title}
										truncationWidth={index === 0 ? 160 : 240}
										clickEventAnalyticsAttributes={editorBreadcrumbClickAnalytics({
											nestedDepth,
										})}
									/>
								);
							})}
					</AkBreadcrumbs>
				)}
			</RoutesContext.Consumer>
		);
	}
}

Breadcrumbs.propTypes = {
	breadcrumbs: PropTypes.array,
	origin: PropTypes.string,
	contentType: PropTypes.string,
	contentId: PropTypes.string,
	maxItems: PropTypes.number,
	itemsBeforeCollapse: PropTypes.number,
	itemsAfterCollapse: PropTypes.number,
	clickHandler: PropTypes.func,
	disabled: PropTypes.bool,
};
